import { Layout, Step, Stepper } from "@mcleod/components";

export abstract class AutogenLayoutModifyCarrierPay extends Layout {
    step1: Step;
    step2: Step;
    stepper: Stepper;
}
